import { formatPercentChange } from 'utils/analytics/formatPercentChange'
import { formatDollarAmount } from 'utils/formatDollarAmt'
import formatMoney from 'utils/formatMoney'

type ChartSummaryProps = {
  title: string
  value?: number
  label?: string
  timeframe?: string
  changePercent?: number
  hoverChangePercent?: number
  isPrice?: boolean
  valueFormatter?: (value?: number) => string
  showChange?: boolean
}

export default function ChartSummary({
  title,
  value,
  label,
  timeframe,
  changePercent,
  hoverChangePercent,
  isPrice,
  valueFormatter,
  showChange,
}: ChartSummaryProps) {
  const activeChangeValue = hoverChangePercent ?? changePercent
  const shouldShowChange = (showChange ?? true) && activeChangeValue !== undefined
  const changeDisplay =
    shouldShowChange && activeChangeValue !== undefined ? formatPercentChange(activeChangeValue) : undefined
  const formattedValue = valueFormatter
    ? valueFormatter(value)
    : isPrice
    ? formatMoney(value ?? 0)
    : formatDollarAmount(value ?? 0)

  return (
    <div className="grid auto-rows-auto min-h-[72px]">
      <div className="text-sm font-medium text-kodiak-text-secondary">
        {timeframe ? `${title} ${timeframe}` : title}
      </div>
      <div className="text-lg font-medium text-kodiak-text-primary flex items-center gap-2">
        <span>{formattedValue}</span>
        {changeDisplay ? (
          <span className={`text-xs font-medium ${changeDisplay.className}`}>{changeDisplay.text}</span>
        ) : null}
      </div>
      <div className="text-sm font-mono text-kodiak-text-secondary h-5">{label ? `${label} (UTC)` : '\u00A0'}</div>
    </div>
  )
}
